import React from "react";
import UserDefaultAvatar from "assets/img/user.svg";
import { ReactComponent as ChatIcon } from "assets/img/icons/comment.svg";
import { useUserContext } from "store/contexts/userContext";
import classNames from "classnames";

const useStyles = {
  teamName: {
    color: "#ffa100",
    fontSize: "18px",
    fontWeight: 500,
  },
  userName: {
    boxShadow:
      "rgb(60 64 67 / 30%) 0px 1px 2px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px",
    border: "none",
    borderRadius: "5px",
    padding: "10px 17px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  chatIcon: {
    maxWidth: "25px",
    fill: "#575f6b",
    maxHeight: "25px",
  },
  userAvatarName: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  userFullName: {
    fontSize: "15px",
  },
};

export default ({ team, handleChat, loader, userId, showChatBox }) => {
  const classes = useStyles;
  const { user } = useUserContext();

  return (
    <div key={team?.id}>
      <div style={classes.teamName}>{team?.name}</div>
      <div className="usersRoot">
        {team.users.map(
          (memberUser, index) =>
            memberUser?.id !== user?.id && (
              <div
                key={index}
                className={classNames({
                  privateChatStart: !loader ? true : false,
                  privateChatStarting: loader ? true : false,
                  chatMemberBackground:
                    userId === memberUser?.id && showChatBox ? true : false,
                })}
                style={classes.userName}
                onClick={() => handleChat(memberUser?.id, team?.id)}
              >
                <div style={classes.userAvatarName}>
                  <img
                    alt="user-name"
                    style={classes.avatar}
                    src={memberUser?.avatar ?? UserDefaultAvatar}
                    title={memberUser?.full_name.toUpperCase()}
                  />
                  <span style={classes.userFullName}>
                    {memberUser?.full_name}
                  </span>
                </div>
                <div>
                  <ChatIcon style={classes.chatIcon} />
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};
